var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"opacity":1,"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}},[_vm._v(" Loading... ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }